import { Box, Typography } from '@mui/material'

const DEFAULT_IMAGE_CROP = {
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  objectFit: 'cover',
  objectPosition: 'center',
}

const FIGMA_IMAGE_CROP = {
  width: '100%',
  height: '261.57%',
  top: '-55.6%',
  left: 0,
  objectFit: 'unset',
}

export default function ProgramIntroSection({
  image,
  imageAlt,
  paragraphs = [],
  imageCrop = 'default',
}) {
  const introText = Array.isArray(paragraphs) ? paragraphs : [paragraphs].filter(Boolean)
  const cropStyle = imageCrop === 'figma' ? FIGMA_IMAGE_CROP : DEFAULT_IMAGE_CROP
  const useAbsoluteCrop = imageCrop === 'figma'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        gap: { xs: 4, md: 6, lg: '115px' },
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '100%', md: 400, lg: 667 },
          maxWidth: '100%',
          flexShrink: 0,
          height: { xs: 280, sm: 360, md: 400, lg: 480 },
          borderRadius: '20px',
          overflow: 'hidden',
        }}
      >
        {useAbsoluteCrop ? (
          <Box
            component="img"
            src={image}
            alt={imageAlt}
            sx={{
              position: 'absolute',
              display: 'block',
              maxWidth: 'none',
              ...cropStyle,
            }}
          />
        ) : (
          <Box
            component="img"
            src={image}
            alt={imageAlt}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
            }}
          />
        )}
      </Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          minWidth: 0,
        }}
      >
        {introText.map((paragraph) => (
          <Typography
            key={paragraph.slice(0, 40)}
            sx={{
              fontSize: { xs: 18, md: 22, lg: 24 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}
